module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For the immense help he’s given me — medical, psychiatric and literary — not only on this book but on "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Spider")]), _vm._v(" as well — I’d like to express my love and gratitude to my father, Dr Patrick McGrath.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fcc4654","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 69
// module chunks = 0